/**
 * 运维组评价指标相关请求
 */
import request from "@/utils/request";

// 运维组评价指标查询
export const operationGroupAssessmentRequestPath = '/api/dataAnalyze/omMetrics';
export const operationGroupAssessmentRequest = (data: any) => {
  return request.post(operationGroupAssessmentRequestPath, data)
}